import * as T from '../constants/types';
import { hasIdInArray } from '../utils/hasIdInArray';

export const onToggleLayer = (id, additionalLayers) => (dispatch, getState) => {
    const { displayedLayers } = getState();
    const isAlreadyAdded = hasIdInArray(displayedLayers, id);
    let updatedLayers;
    if (isAlreadyAdded) {
        updatedLayers = displayedLayers.filter(({ id: addedId }) => addedId !== id);
    } else {
        updatedLayers = [ ...displayedLayers, {
            id,
            ...(additionalLayers ? {
                additionalLayers: additionalLayers.map(({ id }) => ({ id })),
            } : {}),
        }];
    }
    dispatch({ type: T.TOGGLE_LAYER, payload: updatedLayers });
};
